import React, { useCallback, useEffect, useRef, useState } from "react";
import { FetchFromBackoffice, PostBackoffice } from "../../utils/request";
import { CreateTagResponse, TagList } from "../settings/types";
import CustomButton from "../../components/molecules/button";
import { TagDefenition } from "./types";
import { Tag } from "../../components/molecules/tag";
import { Tooltip } from "@mui/material";

export const RecipeTags = ({ tags, articleNumber, version }: { tags: TagDefenition[] | undefined, articleNumber: string | undefined, version: string }) => {

  const [tagList, setTagList] = useState<TagList[]>([])
  const [workingTags, setWorkingTags] = useState<TagDefenition[]>([])
  const [openTagList, setOpenTagList] = useState<boolean>(false)

  const inputRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
        setOpenTagList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAddRecipeTag = async (tagId:string ) => {

    const addedTag = tagList.find((t) => t.tagId === tagId)

    const isAdded = workingTags.some((t) => t.name === addedTag?.text)

    if (isAdded) return
    
    setWorkingTags((prev) => [...prev, {"color_code": addedTag?.colorCode, "name": addedTag?.text }]);

    try {
      const res = await PostBackoffice<CreateTagResponse>("cmd/recipe/tag/add", {
        id: articleNumber,
        tag: tagId,
        version: version
      });

    } catch (error) {
      setWorkingTags((current) => [...current.filter((t) => t.name?.toLocaleLowerCase() !== addedTag?.text.toLocaleLowerCase())])
      console.error("Could not add tag:", error);
    }
  };

  const handleRemoveRecipeTags =  useCallback( async (tagToRemove: string) => {
    
    const removeTag = tagList.find((t) => t.text === tagToRemove)

    if (!removeTag)
      return

    try {

      setWorkingTags(prev => prev.filter(tag => tag.name !== removeTag.text));
      const body = {
        id: articleNumber,
        tag: removeTag.tagId,
        version: version
      }
      
      await PostBackoffice("cmd/recipe/tag/remove", body);

    } catch (error) {
      console.error("Could not remove tag:", error);
    }
  },[tagList]);

  useEffect(() => {
      const allTags = FetchFromBackoffice<TagList[]>('dashboard/tags')
      .then(r => setTagList(r))
      .catch(e => console.log("Error when setting tagList: ", e))
  }, [])

  useEffect(() => {
    if (tags) {
      setWorkingTags(tags)
    } else {
      setWorkingTags([])
    }
  }, [tags])

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
      <span style={{ display: "flex", gap: 10, flexWrap: "wrap", paddingTop: 4 }}>
        {workingTags.map((tag) => (
            <Tag key={tag.name} text={tag.name} backgroundColor colorCode={tag.color_code} onDelete={handleRemoveRecipeTags} />
        ))}
      </span>

      {openTagList && (
        <div ref={inputRef} style={{ width: "100px", alignSelf: "flex-start", position: "relative" }}>
          <div style={{
            cursor: "pointer",
            width: 195,
            backgroundColor: "white",
            padding: "5px 0",
            borderRadius: "0 4x 4px 0",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.13)",
            position: "absolute",
            maxHeight: 256,
            overflowY: "auto",
            zIndex: 10,
          }}>

          {tagList
            .filter(tagNew => !workingTags?.some(tag => tag.name === tagNew.text))
            .map((tagNew) => (
              <Tooltip title={tagNew.text} key={tagNew.tagId} placement="top">
                <div
                  onClick={() => handleAddRecipeTag(tagNew.tagId)}
                  style={{
                    padding: "8px 0",
                  }}
                >
                  <Tag text={tagNew.text} colorCodeCircle colorCode={tagNew.colorCode ?? ""} />
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      )}
      <div style={{ visibility: openTagList ? "hidden" : "visible" }}>
        <CustomButton noBg onClick={() => {
          setOpenTagList(true)
        }}>
          {'+ Add Tag'}
        </CustomButton>
      </div>

    </div>
  )
}

